<template>
  <!-- Table Container Card -->
  <b-card
    no-body
  >
    <div class="m-2">
      <b-row>
        <b-col
          cols="12"
          md="6"
          class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
        >
          <!-- Per Page -->
          <list-per-page
            :total="total"
            :current-per-page="perPage"
            @onChangePerPage="changePerPage"
          />
        </b-col>
        <!-- Search -->
        <b-col
          cols="12"
          md="6"
        >
          <div class="d-flex align-items-center justify-content-end">
            <list-search @onSearch="search" />
          </div>
        </b-col>
      </b-row>
    </div>
    <table-loader v-if="loader" />
    <checkouts-list
      v-else
      :fields="fields"
      :items="items"
      :sort-key="sortKey"
      :sort-type="sortType"
      :additional-data="additionalData"
      :list-filters="additionalData.filters"
      :filters="filters"
      @onSortByChange="changeSortKey"
      @onSortDescChange="changeSortType"
      @onFilterChange="filterChange"
      @onFilterButtonClicked="getData"
    />

    <list-pagination
      :current="page"
      :current-per-page="perPage"
      :from="from"
      :to="to"
      :total="total"
      :total-page="totalPage"
      @onChangePage="changePage"
    />
  </b-card>
</template>

<script>
import { ListIndex } from '../../common/mixins/list'
import CheckoutsList from '../../components/checkouts/list/CheckoutsList'

export default {
  components: {
    CheckoutsList,
  },
  mixins: [ListIndex],
  data() {
    return {
      routeName: 'checkouts',
      userFields: [
        {
          key: 'payment.user',
          label: this.$t('User'),
        },
        {
          key: 'percent',
          label: this.$t('Percent'),
        },
        {
          key: 'amount',
          label: this.$t('Amount'),
        },
        {
          key: 'status',
          label: this.$t('Status'),
        },
        {
          key: 'created_at',
          label: this.$t('Created at'),
        },
      ],
      adminFields: [
        {
          key: 'user',
          label: this.$t('User'),
        },
        {
          key: 'raw_amount',
          label: this.$t('Raw amount'),
        },
        {
          key: 'fee',
          label: this.$t('Fee'),
        },
        {
          key: 'fee_amount',
          label: this.$t('Fee amount'),
        },
        {
          key: 'amount',
          label: this.$t('Payable amount'),
        },
        {
          key: 'status',
          label: this.$t('Status'),
        },
        {
          key: 'created_at',
          label: this.$t('Created at'),
        },
        {
          key: 'action',
          label: '',
        },
      ],
    }
  },
}
</script>

<style lang="scss">

</style>
